export default {
  isMobile(state) {
    return state.screenWidth < 769;
  },
};
